var _metadata, _glyph, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSimpleLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 1000,
    viewBox: "0 0 1000 1000",
    width: 1000,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "IcoFont Icons")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "simple-left") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _glyph || (_glyph = /*#__PURE__*/React.createElement("glyph", {
    glyphName: "simple-left",
    unicode: "\uEAB5",
    horizAdvX: 1000
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M607.4 200l-300 300 300 300 85.10000000000002-85.10000000000002-214.8-214.89999999999998 214.90000000000003-214.89999999999998z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimpleLeft);
export default __webpack_public_path__ + "static/media/simple-left.475e3953.svg";
export { ForwardRef as ReactComponent };